import { useQuery } from "@tanstack/react-query";
import { BanksFinanceAccountsResponse } from "@/types";
import { httpRequest } from "@/lib/axios";

async function fetchBanksFinanceAccounts(): Promise<BanksFinanceAccountsResponse> {
  const response = await httpRequest.get<BanksFinanceAccountsResponse>(
    `/banks`
  );
  return response.data;
}

export function useFetchBanksFinanceAccountsQuery() {
  const banksResponseQuery = useQuery({
    queryKey: ["banks"],
    queryFn: () => fetchBanksFinanceAccounts(),
    keepPreviousData: true,
  });

  return {
    ...banksResponseQuery,
    data: banksResponseQuery?.data,
  };
}
